<template>
  <v-dialog max-width="1000px" scrollable persistent :value="value">
    <v-card color="kbLight">
      <v-toolbar color="kbLight" flat max-height="64px">
        <span class="text-h5 kbDarkBlueText--text text-capitalize font-weight-medium">
          {{ `${$t('general.customizeDay')} - ${selectedDayName}` }}
        </span>
        <v-spacer></v-spacer>
        <v-btn color="kbDarkBlueText" icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider/>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="pb-0">
              <span class="kbDarkBlueText--text d-block text-h6 font-weight-regular">
                {{ $t('general.isDayActive') }}
              </span>
              <v-switch color="kbBlue"
                        :dark="$vuetify.theme.isDark"
                        v-model="isDayActive" />
            </v-col>

            <template v-if="isDayActive">
              <v-col cols="12">
                <v-divider />
              </v-col>

              <v-col cols="12" class="pb-0">
                <span class="kbDarkBlueText--text d-block text-h6 font-weight-regular mb-2">
                  {{ $t('general.pickStartingTime') }}
                </span>

                <PickHour :hour="day.startAtHour"
                          :minute="day.startAtMinute"
                          @onHourChange="day.startAtHour = $event.value"
                          @onMinuteChange="day.startAtMinute = $event.value"/>
              </v-col>

              <v-col cols="12">
                <v-divider />
              </v-col>

              <v-col cols="12" class="pb-0">
                <span class="kbDarkBlueText--text d-block text-h6 font-weight-regular">
                  {{ $t('general.pickFinishingTime') }}
                </span>

                <PickHour :hour="day.finishAtHour"
                          :minute="day.finishAtMinute"
                          @onHourChange="day.finishAtHour = $event.value"
                          @onMinuteChange="day.finishAtMinute = $event.value"/>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          color="kbBlue"
          class="mr-2"
          outlined
          @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          color="kbBlue"
          dark
          @click="submit()">
          {{ $t('general.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/libs/rules'
import PickHour from '@/pages/App/Sequences/widgets/Scheduler/PickHour'
export default {
  components: { PickHour },
  computed: {
    isSelectedDayNotEmpty () {
      return !(!this.selectedDay || typeof this.selectedDay !== 'object' || !Object.keys(this.selectedDay).length)
    }
  },
  data () {
    return {
      day: {
        startAtHour: 0,
        startAtMinute: 0,
        finishAtHour: 23,
        finishAtMinute: 59,
        timeZone: 'America/New_York'
      },
      isDayActive: false,
      rules
    }
  },
  methods: {
    clearLocalDay () {
      this.day = {
        startAtHour: 0,
        startAtMinute: 0,
        finishAtHour: 23,
        finishAtMinute: 59,
        timeZone: 'America/New_York'
      }
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      this.$emit('onDayCustomized', { day: this.day, isDayActive: this.isDayActive })
      this.toggleModal()
    },
    setLocalDay () {
      if (this.isSelectedDayNotEmpty) {
        this.day = { ...this.selectedDay }
      } else {
        this.day.dayOfTheWeek = this.selectedDayId
      }
      this.isDayActive = this.isSelectedDayActive
    },
    toggleModal () {
      this.clearLocalDay()
      this.$emit('input', false)
    }
  },
  props: {
    isSelectedDayActive: {
      type: Boolean,
      required: true
    },
    selectedDayName: {
      type: String,
      required: true
    },
    selectedDay: {
      type: Object,
      default: () => {}
    },
    selectedDayId: {
      type: Number,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (value) {
      if (value) {
        this.setLocalDay()
      }
    }
  }
}
</script>
